import { Link } from "react-router-dom";
const DesktopForgotPasswordForm = ({
	register,
	errors,
	handleSubmit,
	onSubmit,
}) => {
	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex flex-col gap-[16px]"
		>
			{/* Email Input */}
			<input
				type="text"
				placeholder="Email"
				{...register("email")}
				className="w-[321px] h-[33px] rounded-[8px] border border-[#193D34] p-[8px] outline-none"
			/>
			{errors.email && (
				<p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
			)}
			<div className="w-[135px] h-[82px] flex flex-col items-center justify-center mx-auto gap-[16px]">
				<button
					className="w-[185px] h-[32px] flex items-center justify-center rounded-[24px] p-[8px] bg-[#B7D974] text-[#193D34] text-[13px] font-[500] font-montserrat leading-[24px] text-center"
					type="submit"
				>
					Send Request
				</button>
			</div>
		</form>
	);
};

export default DesktopForgotPasswordForm;
